import {
  Action,
  WelcomeError,
  JWT,
  RedirectType,
  WelcomeErrorCode,
  WelcomeFieldError,
} from '../types';
import { detectClient } from '../utilities/client';

export interface State {
  formError: WelcomeErrorCode | null;
  error: WelcomeError | null;
  fieldErrors: WelcomeFieldError;
  isLoading: boolean;
  isMobile: boolean;
  redirectTo: string | null;
  recoveryToken?: JWT;
  redirectType: RedirectType;
  email: string;
  displayName?: string;
  shouldSkipCaptcha: boolean;
}

export const defaultState: State = {
  error: null,
  formError: null,
  fieldErrors: {},
  isLoading: false,
  isMobile: detectClient().atlassianMobileApp,
  redirectTo: null,
  redirectType: RedirectType.Migration,
  email: '',
  shouldSkipCaptcha: false,
};

const welcome = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'WELCOME_SIGNUP_RESET':
      return defaultState;
    case 'WELCOME_SIGNUP_REQUEST':
      return {
        ...state,
        error: null,
        formError: null,
        fieldErrors: {},
        isLoading: true,
      };
    case 'WELCOME_SIGNUP_REQUEST_SUCCESS':
      return {
        ...state,
        isLoading: false,
        fieldErrors: {},
        redirectTo: action.redirectTo,
      };
    case 'WELCOME_SIGNUP_REQUEST_FAILED':
      return {
        ...state,
        error: null,
        formError: action.formError,
        isLoading: false,
      };
    case 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS':
      return {
        ...state,
        fieldErrors: action.errors,
        isLoading: false,
      };
    case 'WELCOME_SIGNUP_SET_STATE':
      return {
        ...state,
        ...(action.state.recoveryToken && { recoveryToken: action.state.recoveryToken }),
        redirectType: action.state.redirectType,
        shouldSkipCaptcha: action.state.shouldSkipCaptcha,
        email: action.state.email,
        ...(action.state.displayName && { displayName: action.state.displayName }),
        // We don't set `isLoading: false` as that's for the welcome form submission loading,
        // whereas this action is for setting the initial page state.
      };
    default:
      return state;
  }
};

export default welcome;
